import React from "react";
import { FiArrowUpRight, FiCalendar } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { normalizeLang } from "../../../utils/localeDataLoader";

const formatNewsDate = (value, languageCode) => {
  if (!value) return "";

  return new Date(value).toLocaleDateString(
    languageCode === "vi" ? "vi-VN" : "en-US",
  );
};

function NewsCategory({ categoryID, newsItems = [] }) {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const languageCode = normalizeLang(i18n.language);
  const articles = newsItems.filter(
    (item) => item.newsCategoryId === categoryID,
  );
  const chunks = [];
  for (let i = 0; i < articles.length; i += 5) {
    chunks.push(articles.slice(i, i + 5));
  }

  const openArticle = (article) => {
    const basePath = languageCode === "en" ? "/news" : "/tin-tuc";
    navigate(`${basePath}/${article.slug}`);
  };

  const renderArticleTitle = (article) => article.title;
  const renderArticleImage = (article) => article.images?.[0]?.imageUrl;

  if (chunks.length === 0) return null;

  return (
    <div className="news-category-list">
      {chunks.map((chunk, index) => {
        const featuredArticle = chunk[0];
        const otherArticles = chunk.slice(1);

        return (
          <div className="news-category-grid" key={index}>
            <button
              type="button"
              className="news-category-grid__featured"
              onClick={() => openArticle(featuredArticle)}
            >
              <span className="news-category-grid__featured-media">
                <img
                  src={renderArticleImage(featuredArticle)}
                  alt={renderArticleTitle(featuredArticle)}
                />
              </span>
              <span className="news-category-grid__featured-content">
                {featuredArticle.publishedAt && (
                  <span className="news-category-grid__date">
                    <FiCalendar aria-hidden="true" />
                    {formatNewsDate(featuredArticle.publishedAt, languageCode)}
                  </span>
                )}
                <strong>{renderArticleTitle(featuredArticle)}</strong>
                {featuredArticle.summary && (
                  <p className="news-category-grid__summary">
                    {featuredArticle.summary}
                  </p>
                )}
              </span>
            </button>

            {otherArticles.length > 0 && (
              <div className="news-category-grid__secondary">
                {otherArticles.map((article) => (
                  <button
                    type="button"
                    className="news-category-grid__card"
                    key={article.id}
                    onClick={() => openArticle(article)}
                  >
                    <span className="news-category-grid__card-media">
                      <img
                        src={renderArticleImage(article)}
                        alt={renderArticleTitle(article)}
                      />
                    </span>
                    <span className="news-category-grid__card-content">
                      {article.publishedAt && (
                        <span className="news-category-grid__date">
                          <FiCalendar aria-hidden="true" />
                          {formatNewsDate(article.publishedAt, languageCode)}
                        </span>
                      )}
                      <strong>{renderArticleTitle(article)}</strong>
                      {article.summary && (
                        <p className="news-category-grid__card-summary">
                          {article.summary}
                        </p>
                      )}
                    </span>
                  </button>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default NewsCategory;